/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs */

const en_register_onboarding_personal_info_fill_form_title_short = /** @type {(inputs: Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in manually `)
};

const de_register_onboarding_personal_info_fill_form_title_short = /** @type {(inputs: Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell ausfüllen`)
};

/**
* | output |
* | --- |
* | "Fill in manually" |
*
* @param {Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_fill_form_title_short = /** @type {((inputs?: Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Fill_Form_Title_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_fill_form_title_short(inputs)
	return en_register_onboarding_personal_info_fill_form_title_short(inputs)
});